import { Account } from '@/domain/usecases'
import { formatUpgradeRequestSettings } from '@/data/services/upgrade/upgrade-service-utils'
import { requestSettingsQueryOptions } from '@/data/services/request-settings/request-settings-service'
import { queryClient } from '@/infra/http'

/**
 * Loads upgrade request settings for company manager
 * Fetches company upgrade request configuration
 */
export async function loadCompanyManagerUpgradeRequest(account: Account.Model) {
  const settings = await queryClient.fetchQuery(
    requestSettingsQueryOptions(account.company.uniqueId)
  )

  return formatUpgradeRequestSettings(settings)
}
